import { CloseOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, Space } from 'antd';

const ContentForm = ({ propKey, msg }) => {
	return (
		<Form.List name={propKey}>
			{(fields, { add, remove }) => (
				<div
					style={{
						display: 'flex',
						rowGap: 16,
						flexDirection: 'column',
						marginBottom: 30
					}}
				>
					{fields.map((field) => (
						<Card
							size="small"
							title={`第 ${field.name + 1}章`}
							key={field.key}
							extra={
								<CloseOutlined
									onClick={() => {
										remove(field.name);
									}}
								/>
							}
						>
							<Form.Item label="二级标题" name={[field.name, 'title']} rules={[
								{
									required: true,
									message: msg
								},
							]}>
								<Input />
							</Form.Item>

							<Form.Item>
								<Form.List name={[field.name, 'paragraphParams']}>
									{(subFields, subOpt) => (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												rowGap: 16,
											}}
										>
											{subFields.map((subField) => (
												<Space key={subField.key} style={{ border: "1px dashed #d9d9d9", padding: "10px 20px 0" }}>
													<div style={{ width: "500px", marginRight: 30 }}>
														<Form.Item label="内容" name={[subField.name, 'text']}>
															<Input.TextArea rows={4} />
														</Form.Item>
														<Form.Item label="图片id" name={[subField.name, 'imageFileUuid']}>
															<Input />
														</Form.Item>
														<Form.Item label="图片标题" name={[subField.name, 'imageName']}>
															<Input />
														</Form.Item>
													</div>
													<CloseOutlined
														onClick={() => {
															subOpt.remove(subField.name);
														}}
													/>
												</Space>
											))}
											<Button type="dashed" onClick={() => subOpt.add()} block>
												+ 添加段落
											</Button>
										</div>
									)}
								</Form.List>
							</Form.Item>
						</Card>
					))}

					<Button type="dashed" onClick={() => add()} block>
						+ 添加章节
					</Button>
				</div>
			)}
		</Form.List>
	);
};
export default ContentForm;